// Import React
import React from "react";

// Import React DOM
import ReactDOM from "react-dom/client";

// Import the root app component
import App from "./App";

// Import the global stylesheet
import "global/css/Global.css";

// Import the config context
import { AppConfigContext } from "global/context/AppConfigContext";

// Import the config loader
import { LoadAppConfig } from "global/config/LoadAppConfig";

// Import the config store setter
import { SetAppConfig } from "global/config/AppConfigStore";

// Import default font loader.
import { LoadDefaultFonts } from "global/utilities/fonts/FontManager";



// Create a reusable function to make sure a portal root exists
const EnsurePortalRoot = (portalRootId) => {

    // Try to find an existing portal root
    const existingPortalRoot = document.getElementById(portalRootId);

    // If the portal root already exists, return it
    if (existingPortalRoot) {

        // Return the existing portal root
        return existingPortalRoot;

    }

    // Create a new portal root element
    const portalRoot = document.createElement("div");

    // Set the portal root id
    portalRoot.id = portalRootId;

    // Add the portal root to the end of the body
    document.body.appendChild(portalRoot);

    // Return the new portal root
    return portalRoot;

};



// Create an async bootstrap function
const BootstrapApplication = async () => {

    try {

        // Load the runtime config before rendering the app
        const appConfig = await LoadAppConfig();

        // Store the loaded config for non-React files like api helpers
        SetAppConfig(appConfig);

        // Load the application's default fonts.
        LoadDefaultFonts();
        
        // Make sure the floating UI portal root exists
        EnsurePortalRoot("floating-ui-root");

        // Find the root element
        const rootElement = document.getElementById("root");

        // Create the React root
        const root = ReactDOM.createRoot(rootElement);



        // Render the application with config available globally
        root.render(
            <React.StrictMode>
                <AppConfigContext.Provider value={appConfig}>
                    <App />
                </AppConfigContext.Provider>
            </React.StrictMode>
        );

    } catch (error) {

        // Write the startup error to the console
        console.error("Application failed to start because app config could not be loaded.", error);

        // Render a simple error fallback into the page
        document.body.innerHTML = `
            <div style="padding: 20px; font-family: sans-serif;">
                <h1>Application configuration failed to load</h1>
                <p>Please check that the application config is available.</p>
            </div>
        `;

    }

};

// Start the application
BootstrapApplication();